module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splashPost",
    class: {
      expanded: _vm.showSplash
    }
  }, [_c('div', {
    staticClass: "splashTextContentWrap"
  }, [_c('div', {
    staticClass: "titleWrap"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: 'year/' + _vm.year,
        query: {
          yearview: _vm.yearviewIndex
        }
      }
    }
  }, [_c('h1', {
    staticClass: "splashTitle",
    style: ({
      color: this.yearColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.yearTitle)
    }
  })])], 1), _vm._v(" "), (_vm.featuredimageSplash) ? _c('div', {
    staticClass: "blurbWrap",
    style: ({
      color: this.yearColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.splashExcerpt)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "splashImage"
  }, [(!_vm.featuredimageSplash) ? _c('div', {
    staticClass: "blurbWrap",
    style: ({
      color: this.yearColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.splashExcerpt)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.featuredimageSplash) ? _c('div', {
    staticClass: "splashImageInner"
  }, [_c('img', {
    attrs: {
      "src": _vm.featuredimageSplash.sizes.large
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "navigationWrap",
    style: ({
      color: this.yearColor,
      'border-color': this.yearColor
    })
  }, [_c('div', {
    staticClass: "border-right singleContentInnerLinkOuter",
    style: ({
      'border-color': this.yearColor
    }),
    on: {
      "click": function($event) {
        _vm.goToGraduates()
      }
    }
  }, [_c('span', [_vm._v("Graduates")])]), _vm._v(" "), _c('div', {
    staticClass: "singleContentInnerLinkOuter",
    style: ({
      color: this.yearColor,
      'border-color': this.yearColor
    })
  }, [(this.splashProgramme) ? [_c('div', {
    staticClass: "singleContentInnerLink border-right",
    style: ({
      'border-color': this.yearColor
    }),
    on: {
      "click": function($event) {
        _vm.expandedProgramme = !_vm.expandedProgramme
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "singleContentInnerLink"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: 'year/' + _vm.year,
        query: {
          yearview: _vm.yearviewIndex
        }
      }
    }
  }, [_c('div', [_c('span', [_vm._v("Read More")])])])], 1)] : [_c('div', {}, [_c('router-link', {
    attrs: {
      "to": {
        path: 'year/' + _vm.year,
        query: {
          yearview: _vm.yearviewIndex
        }
      }
    }
  }, [_c('div', [_c('span', [_vm._v("Read More")])])])], 1)]], 2)]), _vm._v(" "), (_vm.expandedProgramme) ? _c('div', {
    staticClass: "splashProgramme",
    style: ({
      'color': this.yearColor,
      'border-color': this.yearColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.splashProgramme)
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_c('span', [_vm._v("Programme")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2623a0f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Splashposts.vue
// module id = 56
// module chunks = 1